import { render, staticRenderFns } from "./RegisterDiscarLotProduction.vue?vue&type=template&id=728491a8"
import script from "./RegisterDiscarLotProduction.vue?vue&type=script&lang=js"
export * from "./RegisterDiscarLotProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports